<template>
  <div class="repeat">
    <div
      class="input-wrapper all-day-wrapper timing-wrapper repeat main-content"
      @click="displayOption('root')"
    >
      <div class="title-wrapper position-relative">
        <span class="ver-center">Repeat</span>
      </div>
      <div class="content-wrapper position-relative repeat-section">
        <span class="ver-center value-text r-0">
          {{ repeatValue }}
          <object
            class="right-icon"
            :data="rightArrow"
            type="image/svg+xml"
          ></object>
        </span>
      </div>
    </div>

    <!-- Level 0 repeat options -->
    <transition name="slide-left">
      <repeat-vue
        v-if="display"
        :done="done"
        :displayOption="displayOption"
        v-scroll-lock
      />
    </transition>
  </div>
</template>

<script>
import RepeatVue from "../Expand/Repeat.vue";
import { mapGetters, mapMutations } from "vuex";

export default {
  props: {
    clientOrOtherClicked: Boolean
  },
  data() {
    return {
      display: false, // Display the 1st level options
      displayCustom: false // Display second level options
    };
  },
  computed: {
    ...mapGetters({
      getRepeat: "getRepeat",
      selectedYear: "getSelectedYear",
      selectedMonth: "getSelectedMonth",
      selectedDayOfMonth: "getSelectedDayOfMonth",
      getEndRepeat: "getEndRepeat"
    }),
    /**
     * The value of the field that is to be shown to the user
     */
    repeatValue() {
      return this.getRepeat[this.getRepeat.innerOrOuter + "Options"][
        this.getRepeat.selectedIndex
      ];
    },
    rightArrow() {
      return require("../../../../assets/svg/right-arrow.svg");
    }
  },
  methods: {
    ...mapMutations({
      setEndRepeat: "setEndRepeat",
      setSecondLevelHeaderActive: "setSecondLevelHeaderActive"
    }),
    /**
     * Function to close a tab
     */
    done(value = "root") {
      switch (value) {
        case "root":
          this.display = false;
          this.setSecondLevelHeaderActive(false);
          break;

        case "options":
          this.displayCustom = false;
          break;

        default:
          break;
      }
    },
    /**
     * Function to open an option tab
     */
    displayOption(value = "root") {
      switch (value) {
        case "root":
          this.display = true;
          this.setSecondLevelHeaderActive(true);
          break;

        case "options":
          this.displayCustom = true;
          break;

        default:
          break;
      }
    }
  },
  components: {
    RepeatVue
  },
  watch: {
    /**
     * Weather the client or others is clicked
     */
    clientOrOtherClicked(value) {
      if (value) {
        this.done();
      }
    }
  },
  created() {
    // Only setting the end repeat date if not set from before
    if (this.getEndRepeat.year === 0 || this.getEndRepeat.dayOfMonth === 0) {
      this.setEndRepeat({
        dayOfMonth: this.selectedDayOfMonth,
        month: this.selectedMonth,
        year: this.selectedYear + 1,
        never: true
      });
    }
  }
};
</script>

<style scoped>
.title-wrapper.position-relative {
  width: 40%;
}

.content-wrapper {
  padding-right: 10px;
  width: calc(60% - 10px) !important;
}
.repeat-section {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.repeat-section .value-text {
  overflow: hidden;
  width: 96%;
  text-overflow: ellipsis;
  right: 0px;
  max-width: 195px;
  text-align: right;
}
.repeat-section .value-text .right-icon {
  top: 2px;
}
</style>
